import React, { useEffect, useState } from 'react';
import axiosInstance from '../config/axios';

function MyProfilePage() {
  const [email, setEmail] = useState('');
  const [shippingAddress, setShippingAddress] = useState('');
  const [password, setPassword] = useState('');
  const [username, setUsername] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const { data } = await axiosInstance.get('/api/users/profile');
        setUsername(data.username || '');
        setEmail(data.email || '');
        setShippingAddress(data.shippingAddress || '');
      } catch (err) {
        setError('Error fetching profile.');
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
  }, []);

  const handleUpdate = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    try {
      await axiosInstance.put('/api/users/profile', { email, shippingAddress, password });
      setPassword('');
      setSuccess('Profile updated successfully.');
    } catch (err) {
      setError(err.response?.data?.message || 'Error updating profile.');
    }
  };

  if (loading) return <div className="page-shell"><div className="state-card">Loading account...</div></div>;

  return (
    <div className="page-shell">
      <section className="form-layout compact">
        <div className="form-intro">
          <span className="eyebrow">Account</span>
          <h1>Keep your contact and shipping details current.</h1>
          <p>Your username appears on product listings. Email and address stay on your account.</p>
          {username && (
            <div className="profile-badge">
              <span>{username.slice(0, 1).toUpperCase()}</span>
              <strong>{username}</strong>
            </div>
          )}
        </div>

        <form onSubmit={handleUpdate} className="panel-form">
          {error && <div className="notice error">{error}</div>}
          {success && <div className="notice success">{success}</div>}
          <label>
            Email
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              maxLength="320"
              required
            />
          </label>
          <label>
            Shipping Address
            <input
              type="text"
              value={shippingAddress}
              onChange={(e) => setShippingAddress(e.target.value)}
              maxLength="200"
              required
            />
          </label>
          <label>
            New Password
            <input
              type="password"
              placeholder="Leave blank to keep current password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </label>
          <button type="submit" className="button button-primary">
            Save Account
          </button>
        </form>
      </section>
    </div>
  );
}

export default MyProfilePage;
